const lastUpdate = '2026-06-01';
export const helpTitle = 'Saved Maps & Sharing';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>A <strong>saved map</strong> captures your <strong>current map view</strong> so you can return to it later or share it with another EasyMap 3 user. Saving and sharing are the same thing: every saved map has a <strong>permalink</strong>. Whether you click <strong>Save</strong> or <strong>Share</strong>, you name the map, it is saved, and its permalink is copied to your clipboard.</p>

<h2>What a saved map captures</h2>
<ul>
  <li><strong>Map position</strong> — the current centre and zoom level.</li>
  <li><strong>Active layers</strong> — which layers are turned on, their stacking order, and their transparency.</li>
  <li><strong>Background</strong> — the selected basemap.</li>
</ul>

<h2>How to use it</h2>
<ol>
  <li>Click <strong>Save</strong> or <strong>Share</strong> in the Active layers tab and give the map a name. Its permalink is copied to your clipboard automatically.</li>
  <li>Paste the permalink (Ctrl/Cmd&nbsp;+&nbsp;V) into an email, chat message, or duty log to send it to a colleague.</li>
  <li>To re-copy a link later, open <strong>Load</strong> and click the link icon next to the saved map (or use the copy button in the confirmation window).</li>
  <li>When the recipient opens the permalink, EasyMap 3 rebuilds the exact same map view for them.</li>
</ol>

<h2>Global saved maps</h2>
<p>Administrators can mark a saved map as <strong>global</strong> so it is available to every EasyMap 3 user from the Load list, not just the person who created it.</p>

<h2>Important — EasyMap 3 only</h2>
<p>A permalink only works <strong>inside EasyMap 3</strong>. It is intended for sharing a view between EasyMap 3 users — it is not a public link and cannot be opened by anyone who does not have access to EasyMap 3.</p>
<p>If the recipient is not signed in when they open the link, they will be taken to the login page first; once they sign in, EasyMap 3 continues on to the shared map view automatically.</p>

<p class="help-last-update">Last updated: ${lastUpdate}</p>
`;
